import PropTypes from 'prop-types';

const { shape, string } = PropTypes;

export const documentPropTypes = shape({
	country: PropTypes.shape({
		name: PropTypes.string.isRequired,
		code: PropTypes.string.isRequired,
		flag: PropTypes.string.isRequired,
	}),
	url: PropTypes.string.isRequired,
});

export const countryLinkPropTypes = shape({
	brand: string,
	countryName: string,
	countryCode: string,
	continent: string,
	title: string,
	link: string,
	customerServiceLink: string,
	flag: string,
});

export const flagLinkPropTypes = shape({
	title: PropTypes.string.isRequired,
	countryName: PropTypes.string.isRequired,
	flag: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
});

export const pressReleasePropTypes = {
	title: string.isRequired,
	description: string,
	fileUrl: string,
	fileName: string,
	date: string.isRequired,
};
